<script setup lang="ts">
import CmsComponentsListBlock from '~/layers/cms/app/components/cms/CmsComponentsListBlock.vue'
</script>

<template>
  <div>
    <div class="h-18 xl:h-31.5" />
    <CmsComponentsListBlock :cms-data-path="['data']" />
  </div>
</template>
